module.exports = __webpack_public_path__ + "img/logo_x.42cb2741.png";